module.exports = JSON.parse("{\"timestamp\":\"22.10.2026 - 11:43:29\",\"brands\":[]}")